import { useTranslation } from "react-i18next";
import useReaderStore from "../../context/readerStore";
import { useIsMobile } from "../../hooks/useMediaQuery";
import Bookmarks from "../Bookmarks/Bookmarks";
import EmptyState from "../EmptyState/EmptyState";
import FloatingToolbar from "../FloatingToolbar/FloatingToolbar";
import MobileBottomBar from "../Mobile/MobileBottomBar/MobileBottomBar";
import MobileTopBar from "../Mobile/MobileTopBar/MobileTopBar";
import Notes from "../Notes/Notes";
import PagesThumbnails from "../PagesThumbnails/PagesThumbnails";
import PublicationDetails from "../PublicationDetails/PublicationDetails";
import ReadingAssistant from "../ReadingAssistant/ReadingAssistant";
import RightToolbar from "../RightToolbar/RightToolbar";
import SearchSidebar from "../Search/SearchSidebar";
import TableOfContents from "../TableOfContents/TableOfContents";
import Toolbar from "../Toolbar/Toolbar";
import EpubViewerSimple from "../Viewers/EpubViewerSimple";
import PdfViewerNew from "../Viewers/PdfViewerNew";
import "./ReaderShell.css";

const ReaderShell = ({ onToggleHelp }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const {
    documentType,
    document,
    isLoading,
    error,
    isTocSidebarOpen,
    isBookmarksSidebarOpen,
    isNotesSidebarOpen,
    isSearchSidebarOpen,
    isPagesSidebarOpen,
    isReadingAssistantSidebarOpen,
    isPublicationDetailsSidebarOpen,
  } = useReaderStore();

  // No default document loaded

  return (
    <div className="reader-shell">
      {/* Conditional rendering: Mobile vs Desktop layout */}
      {document && !isMobile && (
        <header role="banner">
          <Toolbar onToggleHelp={onToggleHelp} />
        </header>
      )}

      {document && isMobile && <MobileTopBar onToggleHelp={onToggleHelp} />}

      {document && !isMobile && (
        <aside aria-label={t("readerShell.documentControls")}>
          <RightToolbar />
        </aside>
      )}

      <main role="main" className="reader-content" data-viewer-type={documentType || ""}>
        <div className="viewer-container">
          {isLoading && (
            <div className="loading-overlay" role="status" aria-live="polite">
              <div className="loading-spinner" aria-hidden="true"></div>
              <p>{t("readerShell.loadingDocument")}</p>
            </div>
          )}

          {error && (
            <div className="error-message" role="alert" aria-live="assertive">
              <EmptyState error={error} />
            </div>
          )}

          {!isLoading && !error && documentType === "pdf" && document && (
            <PdfViewerNew />
          )}

          {!isLoading && !error && documentType === "epub" && document && (
            <EpubViewerSimple />
          )}

          {!isLoading && !error && !document && <EmptyState />}
        </div>

        {isTocSidebarOpen && <TableOfContents />}
        {isPagesSidebarOpen && <PagesThumbnails />}
        {isBookmarksSidebarOpen && <Bookmarks />}
        {isNotesSidebarOpen && <Notes />}
        {isSearchSidebarOpen && <SearchSidebar />}
        {isReadingAssistantSidebarOpen && <ReadingAssistant />}
        {isPublicationDetailsSidebarOpen && <PublicationDetails />}

        {document && !isMobile && <FloatingToolbar />}
        {isMobile && document && <MobileBottomBar />}
      </main>
    </div>
  );
};

export default ReaderShell;
